import { defineComponent as _defineComponent } from 'vue'
import { ScanGift } from '@tencent/wphk-components-scan-gift';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import NewUserSmallBar from '@/views/home/new-user-module/small-bar.vue';
import { useIsShowScanGift } from './hooks/use-is-show-scan-gift';

// 针对url不带campaignId，但又需要扫码券礼包模块的商户，hack处理

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const merchantId2ScanGiftId = {
  // merchantId(url上带的参数): campaignIdId(扫码券礼包Id)
  'CM-1617696480669': '711macau', // 双钱包活动-澳门711专属的扫码券礼包Id
};

const { spId } = useMerchantInfo();
// 首先从url获取campaignId，再次从hack中取
// 另外，merchantId要从url中获取，不能从useMerchantInfo()中获取，因为右上角分享出去的url(不带merchantId)不需要展示扫码券礼包模块
const campaignId = getUrlParamByKey(UrlParamKey.campaignId) || merchantId2ScanGiftId[getUrlParamByKey('merchantId' as any)];

const { updateShowState } = useIsShowScanGift();
// 记录状态
function handleShowState(value) {
  updateShowState(value);

  if (value) {
    // 展示扫码券礼包时，隐藏右上角复制入口/分享入口
    wx.hideOptionMenu();
  }
}

return { __sfc: true,merchantId2ScanGiftId, spId, campaignId, updateShowState, handleShowState, ScanGift, NewUserSmallBar }
}

})